import React, { useState } from "react";

import {
  CardExpandContainer,
  CardExpandContainerHeader,
  CardExpandContainerHeaderTitle,
  CardExpandContainerBody,
  CardHomeContentLabel,
  CardHomeContentLabelDecoration,
  CardHomeContentLabelDecorationTikTok,
  CardHomeContentLabelDecorationInstagram,
} from "./styled";

export default function DraggableAccordion({ title, icon, children }) {
  const [active, setActive] = useState(false);

  return (
    <>
      <CardExpandContainer>
        <CardExpandContainerHeader
          closed={!active}
          onClick={() => setActive(!active)}
        >
          <CardExpandContainerHeaderTitle>
            <CardHomeContentLabelDecoration
              icon={icon} />
            <p>
              {title}
            </p>
          </CardExpandContainerHeaderTitle>

          <CardHomeContentLabel>
            <p>Filtro</p>
            <CardHomeContentLabelDecorationTikTok
            />
            <CardHomeContentLabelDecorationInstagram
            />
          </CardHomeContentLabel>
        </CardExpandContainerHeader>

        <CardExpandContainerBody active={active}>
          {children}
        </CardExpandContainerBody>
      </CardExpandContainer>
    </>
  );
}
